export default defineNuxtPlugin({
  name: 'sentryUser',
  parallel: true,
  dependsOn: ['Sentry'],
  async setup () {
    const { setUser } = (await import('@sentry/vue'));

    const userState = useUserState();

    const userName = useUserName();

    watch(userState, (newUserState) => {
      if (newUserState) {
        setUser({
          id: newUserState.sub,
          username: userName.value,
          email: newUserState.email,
        });
      } else {
        setUser(null);
      }
    }, { immediate: true });
  }
});
